// 抽奖弹窗
export default {
    namespaced: true,//开启命名空间
    state: {
        iframeShow: false,
        linkUrl:'',
    },
    mutations: {
        SET_IFRAMESHOW(state, show) {
            state.iframeShow = show
        },
        SET_LINKURL(state, linkUrl) {
            state.linkUrl = linkUrl
        },
    },
    actions: {

    },
    getters: {

    }
}
